import { X } from "lucide-react";

export const ActiveFilterChip = ({ label, onRemove }) => (
  <div className="flex items-center bg-gray-700/50 text-[#D9D9D9] text-xs px-3 py-1 rounded-full border border-green-400">
    <span className="max-w-[120px] truncate">{label}</span>
    <button
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      className="ml-1 hover:opacity-70"
    >
      <X className="w-3 h-3" />
    </button>
  </div>
);